import React, { useState, useEffect } from "react";

const Timer = () => {
    const [elapsedTime, setElapsedTime] = useState(0);

    useEffect(() => {
        let startTime;
        let animationFrameId;

        const startTimer = () => {
            startTime = performance.now();
            const updateElapsedTime = () => {
                const currentTime = performance.now();
                const deltaTime = currentTime - startTime;
                setElapsedTime((prevElapsedTime) => prevElapsedTime + deltaTime);
                startTime = currentTime;
                animationFrameId = requestAnimationFrame(updateElapsedTime);
            };

            animationFrameId = requestAnimationFrame(updateElapsedTime);
        };

        startTimer();

        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []); // Empty dependency array ensures the effect runs only once on mount

    const formatTime = (milliseconds) => {
        const seconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    return <div>Timer: {formatTime(elapsedTime)}</div>;
};

export default Timer;
